import React from 'react'
import { SectionWrapper, TopFlex, TopHeader } from '../../Style/style'
import RuleHeader from '../RuleHeader'
import RulesSetTable from '../RulesSetTable'

const RuleEngineDraft = ({ getRuleSetData, ruleSet, deleteRule }) => {
  return (
    <SectionWrapper>
      <TopHeader row spaceBetween alignCenter>
        <TopFlex column>
          <RuleHeader
            isDraftRuleExist={ruleSet?.isDraftRuleExist}
            initialState={false}
          />
          <RulesSetTable
            data={ruleSet}
            getRuleSetData={getRuleSetData}
            status={0}
            mode="draft"
            deleteRule={deleteRule}
            emptyState
          />
        </TopFlex>
      </TopHeader>
    </SectionWrapper>
  )
}

export default RuleEngineDraft
